import { FC } from "react";

import classNames from "classnames";

import { useTableStyles } from "./TableStylesContext";

/**
 * A table cell tail.
 */
export const TableCellTail: FC = () => {
  const { styles } = useTableStyles();

  return (
    <td className={classNames(styles.TableCell, "table-cell", "tail")}>
      <div className="cell-outer-content">
        <div className="cell-inner-content" />
      </div>
    </td>
  );
};
